export default __webpack_public_path__ + "static/media/callisto-logo.07acd35e.png";